import { createSlice, PayloadAction } from "@reduxjs/toolkit";

interface SelectedCourseDataState {
  selectedCourseData: string[];
  selectedStudentData: string[];
  availableStudents: Array<{
    student_id: string;
    student_name: string;
    img_url: string | null;
  }>;
}

const initialState: SelectedCourseDataState = {
  selectedCourseData: [],
  selectedStudentData: [],
  availableStudents: []
};

const selectedCourseDataSlice = createSlice({
  name: "selectedCourseData",
  initialState,
  reducers: {
    setSelectedCourseData: (state, action: PayloadAction<string[]>) => {
      state.selectedCourseData = action.payload;
    },
    setSelectedStudentData: (state, action: PayloadAction<string[]>) => {
      state.selectedStudentData = action.payload;
    },
    setAvailableStudents: (state, action: PayloadAction<Array<{
      student_id: string;
      student_name: string;
      img_url: string | null;
    }>>) => {
      state.availableStudents = action.payload;
    },
    resetSelectedCourseData: (state) => {
      state.selectedCourseData = [];
      state.selectedStudentData = [];
      state.availableStudents = [];
    }
  }
});

export const {
  setSelectedCourseData,
  setSelectedStudentData,
  setAvailableStudents,
  resetSelectedCourseData
} = selectedCourseDataSlice.actions;

export default selectedCourseDataSlice.reducer;